var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTrophy = function SvgTrophy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.24 1.92h-3.68V.32a.32.32 0 0 0-.32-.32H5.76a.32.32 0 0 0-.32.32v1.6H1.76A1.76 1.76 0 0 0 0 3.68V9.6a6.57 6.57 0 0 0 5.528 6.48 10.245 10.245 0 0 0 9.032 8.82v4.208H6.72c-.708 0-1.28.572-1.28 1.28v1.292c0 .176.144.32.32.32h20.48a.32.32 0 0 0 .32-.32v-1.292c0-.708-.572-1.28-1.28-1.28h-7.84V24.9a10.245 10.245 0 0 0 9.032-8.82A6.57 6.57 0 0 0 32 9.6V3.68a1.76 1.76 0 0 0-1.76-1.76ZM5.44 13.104A3.687 3.687 0 0 1 2.88 9.6V4.8h2.56v8.304ZM29.12 9.6a3.68 3.68 0 0 1-2.56 3.504V4.8h2.56v4.8Z",
    fill: "#FDFDFE"
  })));
};

export default SvgTrophy;